/**
 * This module is in charge of controlling switch visual components.
 */
(function() {

  "use strict";
  var DEFAULT_CONFIG = {
    position: 'RIGHT_TOP',
    modalPosition: 'TOP_CENTER'
  };
  var ID = 0;

  define('fg-arv/components/help',['fg-arv/utils'], function(utils) {

    var module = {
      createComponent: function(config) {
        var container = utils.getPropertyValue(config, 'container');
        if (container) {
          var id = createDomID();
          var conf = jQuery.extend({
            id: id
          }, DEFAULT_CONFIG, config);
          var template = createTemplate(conf);
          container.html(template);
          var map = conf.map;

          var componentElement = jQuery('#' + id);
          var component = {
            init: function(conf) {
              component.initDialog();
            },
            initBtn: function() {
              var resizeTimeout;
              var panelControl = componentElement.find('.help-component')[0];
              jQuery(panelControl).addClass('map-control');
              if (window.innerWidth <= 540) {
                jQuery(panelControl).addClass('hidden');
              }
              jQuery(window).resize(function() {
                if (resizeTimeout) {
                  clearTimeout(resizeTimeout);
                }
                resizeTimeout = setTimeout(function() {
                  if (window.innerWidth <= 540) {
                    jQuery(panelControl).addClass('hidden');
                  } else {
                    jQuery(panelControl).removeClass('hidden');
                  }
                }, 10);
              });
              map.controls[google.maps.ControlPosition[conf.position]].push(panelControl);
            },
            initDialog: function() {
              var dialogHtml = componentElement.find(".dialog-message");
              var panelControl;
              var controls;

              function addDialogToControls() {
                panelControl = dialogHtml.closest('.fg-arv_dialog-container')[0];
                controls = map.controls[google.maps.ControlPosition[conf.modalPosition]].getArray();
                if (jQuery.inArray(panelControl, controls) !== -1) {
                  delete controls[jQuery.inArray(panelControl, controls)];
                  console.log('delete');
                }
                jQuery(panelControl).addClass('map-control');
                map.controls[google.maps.ControlPosition[conf.modalPosition]].push(panelControl);
              }

              dialogHtml.dialog({
                autoOpen: false,
                appendTo: componentElement.find(".fg-arv_dialog-container"),
                modal: true,
                position: {
                  my: 'center',
                  at: 'center',
                  of: conf.widget.widgetElement
                },
                buttons: [{
                  text: "Ok",
                  class: "btn btn-primary",
                  click: function() {
                    jQuery(this).dialog("close");
                  }
                }],
                show: {
                  effect: "blind",
                  duration: 300
                },
                hide: {
                  effect: "blind",
                  duration: 300
                }
              });
              var closeBtn = componentElement.find('.fg-arv_dialog-container .ui-dialog-titlebar-close');
              closeBtn.addClass('glyphicon glyphicon-remove-sign');
              componentElement.find('.help-component').click(function() {
                addDialogToControls();
                dialogHtml.dialog({
                  width: conf.widget.widgetElement.width(),
                  height: conf.widget.widgetElement.height()
                });
                dialogHtml.dialog("open");
              });
              var resizeTimeout;
              jQuery(window).resize(function() {
                if (resizeTimeout) {
                  clearTimeout(resizeTimeout);
                }

                resizeTimeout = setTimeout(function() {
                  dialogHtml.dialog({
                    width: conf.widget.widgetElement.width(),
                    height: conf.widget.widgetElement.height()
                  });

                }, 10);
              });
            },
            getID: function() {
              return id;
            }

          };

          component.init(conf);
          return component;
        }
      }
    };

    return module;

    //*********************************************************

    function createTemplate(config) {
      return "<div id='" + config.id + "'>" +
        "<div  class='help-component'> <div class=' pointer help-btn' title='Help'><span class='help-icon'></span><span class='hidden-md'>Help</span></div></div>" +
        "<div class='fg-arv_dialog-container'>" +
        "<div class='dialog-message' title='Help'>" +
        "<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam volutpat tincidunt massa accumsan commodo. Integer metus purus, hendrerit vitae tellus eu, suscipit hendrerit ante. Nulla sed elit eu dolor euismod scelerisque. Sed ac ligula luctus, porttitor sem non, fermentum justo. Maecenas pellentesque euismod mattis. Curabitur venenatis massa arcu. Donec hendrerit feugiat scelerisque. Vestibulum a turpis at tellus maximus facilisis nec nec nisi. Etiam venenatis tristique eleifend. Sed eget risus ut justo condimentum sagittis ut id est. Morbi porta luctus tincidunt. Aenean porta congue magna vel iaculis.</p>" +

        "<p>Nulla a est sit amet mi ultrices finibus nec vitae mauris. Fusce euismod sollicitudin semper. Aliquam odio nisi, lobortis sed tellus cursus, tincidunt aliquam erat. Nam purus sapien, vestibulum ac urna sit amet, dignissim aliquam sem. Mauris sem quam, finibus id dictum sed, porttitor quis elit. Nullam porta justo massa, in varius magna lobortis at. Fusce mauris libero, suscipit id tortor posuere, mollis aliquam purus. Donec viverra nibh at odio semper scelerisque. Duis augue diam, dictum at sem ac, commodo pulvinar arcu. Maecenas semper velit ligula, eu congue ipsum dignissim quis. In non libero ligula. In hac habitasse platea dictumst. Mauris aliquam orci eget velit ullamcorper mattis. Duis interdum eu dui quis dapibus. Proin efficitur, nunc quis placerat aliquet, turpis tortor mollis sem, molestie facilisis odio libero quis leo.</p>" +
        "</div>" +
        "</div>";
    }


    function createDomID() {
      var i = ++ID;
      return "fg-arv-help-" + i;
    }

  });

})();

